import React from "react";

const CreditCard = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path className="u_fill"
          d="M33.843 27.005c-.02-.027-2.11-2.715-2.79-4.863-.16-.512-.362-1.232-.593-2.059-1.104-3.948-2.11-7.309-3.223-8.423-.846-.845-3.335-1.485-5.465-1.9a.725.725 0 00-.859.717v5.266c0 .258.068.521.2.744.58.985 1.1 1.564 1.365 1.676a.73.73 0 01-.56 1.342c-1.192-.497-2.456-2.75-3.241-4.693-.127-.315-.473-.875-.769-1.312-.917-1.305-2.4-2.793-3.742-3.067-.697-.142-1.312.03-1.781.5-1.752 1.75-.749 4.729.643 6.747 1.113 1.616 1.94 3.523 2.057 4.748.018.205.029.398.036.589.05 1.05.101 2.137 1.555 4.137.783 1.074 1.801 1.69 2.88 2.347 1.478.896 3.009 1.824 4.346 4.122a.746.746 0 00.627.377c6.932.008 9.396-6.222 9.421-6.286a.726.726 0 00-.107-.71zM4.601 2.137a.724.724 0 00-.663-.09A2.94 2.94 0 002 4.807v20.576a2.94 2.94 0 001.938 2.763.722.722 0 00.89-.356.738.738 0 00.08-.337V2.74a.738.738 0 00-.307-.604v.001z"
          fill={fill}
      />
      <path className="u_fill"
          d="M13.68 23.09a9.678 9.678 0 00-.033-.52c-.062-.669-.596-2.304-1.805-4.057-.55-.797-1.83-2.898-1.83-5.156 0-1.367.468-2.556 1.356-3.444.807-.807 1.938-1.134 3.098-.898 1.1.225 2.317 1.01 3.46 2.216v-.006c.013.011.022.025.032.036l.034.032v.007a13.52 13.52 0 011.465 1.924V4.91A2.913 2.913 0 0016.547 2h-8a.727.727 0 00-.728.729v24.727c0 .403.325.729.729.729h5.721a.729.729 0 00.622-1.108c-1.024-1.68-1.157-2.845-1.21-3.988z"
          fill={fill}
      />
    </svg>
);

export default CreditCard;
